export default "/images/staples.svg?4ce54be7a7adbfb7364a9119c6578930";